import { createStore, combineReducers, applyMiddleware, compose } from 'redux';
import thunk from 'redux-thunk';
import {
  addCustomerToUserReducer,
  addUserReducer,
  getRoleReducer,
  getUserByIDReducer,
  getUsersReducer,
  userLoginReducer,
  removeCustomerFromUserReducer,
  resetDeviceIDReducer,
  resetPasswordReducer,
  updateUserReducer,
  userLogoutReducer,
  fetchAttendanceReducer,
  resignUserReducer,
  forceLogoutUserReducer,
  forceLogoutMultipleReducer,
  resetRateLimitReducer,
  deleteUserReducer,
} from './reducers/userReducers';
import {
  addCustomerReducer,
  getCustomersReducer,
  updateCustomerReducer
} from './reducers/customerReducers';
import {
  addRoleReducer,
  getRoleByIDReducer,
  getRolesReducer,
  updateRoleReducer,
} from './reducers/roleReducers';

/* NEW: Loan/QR reducers */
import {
  merchantCreateReducer,
  merchantByQrReducer,
  merchantListReducer,
} from './reducers/merchantReducers';

import {
  enquiryCreateReducer,
  enquiryListReducer,
} from './reducers/enquiryReducers';

const reducer = combineReducers({
  // User reducers
  userLogin: userLoginReducer,
  userLogout: userLogoutReducer,
  getRoleInfo: getRoleReducer,
  getUsersInfo: getUsersReducer,
  addUserInfo: addUserReducer,
  getUserByIDInfo: getUserByIDReducer,
  addCustomerToUserInfo: addCustomerToUserReducer,
  updateUserInfo: updateUserReducer,
  resetDeviceIDInfo: resetDeviceIDReducer,
  resetPasswordInfo: resetPasswordReducer,
  removeCustomerFromUserInfo: removeCustomerFromUserReducer,
  fetchAttendanceInfo: fetchAttendanceReducer,
  resignUserInfo: resignUserReducer,
  forceLogoutUserInfo: forceLogoutUserReducer,
  forceLogoutMultipleInfo: forceLogoutMultipleReducer,
  resetRateLimitInfo: resetRateLimitReducer,
  deleteUserInfo: deleteUserReducer,

  // Customer reducers
  getCustomersInfo: getCustomersReducer,
  addCustomerInfo: addCustomerReducer,
  updateCustomerInfo: updateCustomerReducer,

  // Role reducers
  getRolesInfo: getRolesReducer,
  addRoleInfo: addRoleReducer,
  getRoleByIDInfo: getRoleByIDReducer,
  updateRoleInfo: updateRoleReducer,

  // NEW: Loan/QR reducers
  merchantCreate: merchantCreateReducer,
  merchantByQr: merchantByQrReducer,
  merchantList: merchantListReducer,

  enquiryCreate: enquiryCreateReducer,
  enquiryList: enquiryListReducer,
});

const userInfoFromStorage = localStorage.getItem('userInfo')
  ? JSON.parse(localStorage.getItem('userInfo'))
  : null;

const inititalState = {
  userLogin: { userInfo: userInfoFromStorage },
};

const middleware = [thunk];

// Conditionally apply Redux DevTools extension
const composeEnhancers = process.env.NODE_ENV === 'development'
  ? window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose
  : compose;

const store = createStore(
  reducer,
  inititalState,
  composeEnhancers(applyMiddleware(...middleware))
);

export default store;
